module.exports = __webpack_public_path__ + "img/right-arrow.cd2e834a.svg";